// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"OI2wtaMv"};